/**
 * Created by zhaoy on 2020/7/13
 * Desc: 学生名单布局
 */

import React, {Component} from 'react'
import RosterBean from 'model/RosterBean'
import 'css/roster-item.css'
import {isObjEmpty} from "../utils/common";
import {Select} from 'antd';

const Option = Select.Option;

export default class RosterItem extends Component {

    constructor() {
        super()

        this.state = {
            albumBean: new RosterBean(),
            messageContent: null
        }
    }

    componentDidMount() {
        this.setState({
            albumBean: this.props.albumBean
        })
    }

    render() {
        const {albumBean} = this.state
        const rosterItemBean = [];
        const rosterItemBean1 = [];
        if (!isObjEmpty(albumBean.parentsList)) {
            for (let i = 0; i < albumBean.parentsList.length; i++) {
                const albumBean1 = albumBean.parentsList[i]
                if (!isObjEmpty(albumBean1)) {
                    rosterItemBean.push(
                        <option className='nameText' key={i}>{albumBean1.parentsName}</option>
                    )
                    rosterItemBean1.push(
                        <option className='nameText' key={i}>{albumBean1.paPhone}    {albumBean1.paBindingState===1?"绑定":"未绑定"}</option>
                    )
                }
            }
        }
        return (
            <div className='header_days_sty'>

                <div className='nameText'>{albumBean.stuName}</div>
                <select className='nameTexts' onClick={this.onChangeItem}>{rosterItemBean}</select>
                <select className='nameTexts' onClick={this.onChangeItem}>{rosterItemBean1}</select>
                <div className='nameText'>{albumBean.stuBindingState}</div>

            </div>

        )
    }

    onChangeItem = (event) => {
        let msg = event.target.value;
        this.setState({
            messageContent: msg
        })
    }
}